function Statement({ label, content, isLink = false }) {
  const renderContent = () => {
    if (Array.isArray(content)) {
  // If this label is about skills, group by category and render once (avoid repeating the list per item)
  const isSkills = typeof label === 'string' && label.toLowerCase().includes('skill');
  const isInterests = typeof label === 'string' && (label.toLowerCase().includes('interest') || label.toLowerCase().includes('hobby'));
  if (isSkills) {
        const toolsSet = new Set(['React', 'Node.js', 'Express', 'Sass']);
        const frameworkSet = new Set(['React', 'Express']);
        const databaseSet = new Set(['MongoDB']);
        const languageSet = new Set(['JavaScript', 'HTML', 'Java', 'C#', 'C++']);

        const toolItems = [];
        const frameworkItems = [];
        const databaseItems = [];
        const languageItems = [];
        const otherItems = [];

        content.forEach((it) => {
          if (frameworkSet.has(it)) frameworkItems.push(it);
          else if (toolsSet.has(it)) toolItems.push(it);
          else if (databaseSet.has(it)) databaseItems.push(it);
          else if (languageSet.has(it)) languageItems.push(it);
          else otherItems.push(it);
        });

        const ordered = [...toolItems, ...frameworkItems, ...databaseItems, ...languageItems, ...otherItems];

        return ordered.map((skill, idx) => {
          let category = '';
          if (frameworkSet.has(skill)) category = 'framework';
          else if (databaseSet.has(skill)) category = 'database';
          else if (languageSet.has(skill)) category = 'language';
          else if (toolsSet.has(skill)) category = 'tool';

          return (
            <span key={skill + idx} className={`token token-string ${category ? `token-${category}` : ''}`}>
              {skill}
              {idx < ordered.length - 1 ? <span className="token token-punctuation">, </span> : null}
            </span>
          );
        });
      }

      // If this label is interests/hobbies, group into simple categories and render grouped
      if (isInterests) {
        const techSet = new Set(['coding', 'reverse engineering']);
        const creativeSet = new Set(['music']);
        const leisureSet = new Set(['gaming']);

        const techItems = [];
        const creativeItems = [];
        const leisureItems = [];
        const otherItems = [];

        content.forEach((it) => {
          const lowered = typeof it === 'string' ? it.toLowerCase() : '';
          if (techSet.has(lowered)) techItems.push(it);
          else if (creativeSet.has(lowered)) creativeItems.push(it);
          else if (leisureSet.has(lowered)) leisureItems.push(it);
          else otherItems.push(it);
        });

        const ordered = [...techItems, ...creativeItems, ...leisureItems, ...otherItems];

        return ordered.map((hobby, idx) => (
          <span key={hobby + idx} className={`token token-string ${
            techItems.includes(hobby) ? 'token-tech' : creativeItems.includes(hobby) ? 'token-creative' : leisureItems.includes(hobby) ? 'token-leisure' : ''
          }`}>
            {hobby}
            {idx < ordered.length - 1 ? <span className="token token-punctuation">, </span> : null}
          </span>
        ));
      }

      // Non-skills array: render each item normally
      return content.map((item, index) => {
        if (typeof item === 'string') {
          return (
            <span key={index} className="token token-string">
              {item}
              {index < content.length - 1 ? <span className="token token-punctuation">, </span> : null}
            </span>
          );
        } else if (isLink && item.text) {
          if (item.onClick) {
            return (
              <span key={index} className="token token-link">
                <button
                  type="button"
                  onClick={item.onClick}
                  className="token-link-anchor token-link-button"
                  aria-label={`Open ${item.text}`}
                >
                  {item.text}
                </button>
                {index < content.length - 1 ? <span className="token token-punctuation">, </span> : null}
              </span>
            );
          }
          if (item.url) {
            return (
              <span key={index} className="token token-link">
                <a
                  href={item.url}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="token-link-anchor"
                  aria-label={`Open ${item.text} link`}
                >
                  {item.text}
                </a>
                {index < content.length - 1 ? <span className="token token-punctuation">, </span> : null}
              </span>
            );
          }
        }
        return null;
      });
    }
    // If content is a primitive, render with default token class
    if (typeof content === 'string' || typeof content === 'number' || typeof content === 'boolean') {
      return <span className="token token-string">{String(content)}</span>;
    }
    return content;
  };

  // Tokenize label into name.property if it contains a dot, else render as-is.
  const renderLabel = (lbl) => {
    if (!lbl || typeof lbl !== 'string') return null;
    const parts = lbl.split('.');
    if (parts.length >= 2) {
      const name = parts.shift();
      const rest = parts.join('.');
      return (
        <span className="token token-label">
          <span className="token token-name">{name}</span>
          <span className="token token-punctuation">.</span>
          <span className="token token-property">{rest}</span>
        </span>
      );
    }
    return <span className="token token-label"><span className="token token-name">{lbl}</span></span>;
  };

  return (
    <div className="statement">
      <div className="input-statement">{renderLabel(label)}</div>
      <div className="return-statement">{renderContent()}</div>
    </div>
  );
}

export default Statement;